import Request from "../lib/request";
import { ANNOUNCEMENTS_API } from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const get = id => {
  return Request({
    method: "get",
    url: `${baseUrl}/${ANNOUNCEMENTS_API}/${id}`,
    needToken: true
  });
};

export const action = (id, action) => {
  return Request({
    method: "put",
    url: `${baseUrl}/${ANNOUNCEMENTS_API}/${id}`,
    needToken: true,
    data: { action: action }
  });
};
